import React from 'react';
import { FadeIn } from './FadeIn';
export function TheBonuses() {
  const bonuses = [{
    num: '01',
    title: 'Partituras de Películas Famosas',
    desc: 'Banco de 30 piezas adaptadas en dominio público + arreglos originales de melodías icónicas en 4 niveles · Lo que tus alumnos siempre quisieron tocar',
    value: '$12.000'
  }, {
    num: '02',
    title: 'Manual de Supervivencia del Profesor de Piano',
    desc: 'Los problemas reales del oficio que nadie te enseñó · Cómo manejar deserción, padres difíciles, tu agotamiento, la soledad del oficio · 25 capítulos',
    value: '$10.000'
  }, {
    num: '03',
    title: 'Diccionario del Piano: 200 Términos para Profesores',
    desc: '200 conceptos musicales con explicación pedagógica para 3 edades (niño, adolescente, adulto) · Tu referencia perpetua para explicar bien',
    value: '$11.000'
  }, {
    num: '04',
    title: 'Tu Marca Personal como Profesor',
    desc: 'Cómo construir tu identidad profesional · Posicionarte sin volverte influencer · Estudio físico como manifestación de marca · Fotografía profesional',
    value: '$9.000'
  }, {
    num: '05',
    title: 'Cómo Cobrar lo que Vales',
    desc: 'Guía completa de honorarios para profesores de piano · Cómo subir precios sin perder alumnos · Política de cancelaciones · Cálculo de hora real',
    value: '$10.000'
  }, {
    num: '06',
    title: 'Instagram y Redes para Profesores de Piano',
    desc: 'Estrategia realista de redes sociales sin volverte esclavo · 7 categorías de contenido · WhatsApp Business · Cómo aparecer en búsquedas locales',
    value: '$9.000'
  }];
  return <section className="bg-navy-900 py-24 relative border-t border-gold/10" data-id="element-275">
      <div className="container mx-auto px-6" data-id="element-276">
        <FadeIn className="text-center mb-16" data-id="element-277">
          <h2 className="font-display font-bold text-4xl md:text-5xl text-white mb-4" data-id="element-278">
            Más los 6 Bonos Estratégicos
          </h2>
          <p className="inline-block bg-gold/10 border border-gold/30 text-gold px-6 py-2 rounded-full font-medium text-sm md:text-base" data-id="element-279">
            Solo en el MegaPack PIANO LISTO PREMIUM — Valor adicional sin
            precedentes
          </p>
        </FadeIn>

        <div className="grid grid-cols-2 gap-3 sm:gap-4 max-w-3xl mx-auto mb-16" data-id="element-280">
          {bonuses.map((bonus, i) => <FadeIn key={i} delay={0.05 * i} direction="up" data-id="element-281">
              <div className="bg-navy-800 border border-gold/20 p-3 sm:p-4 rounded-lg h-full flex flex-col relative overflow-hidden group hover:border-gold/50 transition-colors" data-id="element-282">
                <div className="flex items-center gap-2 mb-2 relative z-10" data-id="element-283">
                  <span className="bg-gold text-navy-900 font-numbers font-bold w-6 h-6 flex items-center justify-center rounded text-xs" data-id="element-284">
                    {bonus.num}
                  </span>
                  <span className="text-gold font-bold tracking-wide text-xs" data-id="element-285">
                    🎁 BONO {parseInt(bonus.num)}
                  </span>
                </div>

                <h4 className="font-bold text-sm sm:text-base text-white mb-1.5 relative z-10 leading-tight" data-id="element-286">
                  {bonus.title}
                </h4>
                <p className="text-gray-400 text-xs leading-relaxed mb-3 flex-grow relative z-10 hidden sm:block" data-id="element-287">
                  {bonus.desc}
                </p>

                <div className="flex items-center gap-2 pt-2 border-t border-white/5 relative z-10" data-id="element-288">
                  <span className="text-gray-500 line-through font-numbers text-xs sm:text-sm" data-id="element-289">
                    {bonus.value}
                  </span>
                  <span className="text-success font-bold text-xs sm:text-sm" data-id="element-290">
                    GRATIS
                  </span>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-291">
          <div className="max-w-2xl mx-auto bg-gradient-to-r from-gold-dark/20 via-gold/10 to-gold-dark/20 border border-gold p-8 rounded-xl text-center shadow-[0_0_30px_rgba(212,180,100,0.15)]" data-id="element-292">
            <p className="text-gray-300 mb-2 font-medium" data-id="element-293">
              Valor total de los 6 Bonos:{' '}
              <span className="font-numbers text-xl line-through opacity-70" data-id="element-294">
                $61.000 ARS
              </span>
            </p>
            <p className="font-display font-bold text-3xl md:text-4xl text-gold" data-id="element-295">
              🎁 GRATIS — Solo en el plan PREMIUM
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}